// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-modal_videoWrapper__9aRBI iframe {
  width: 100%;
  height: 100vh;
  max-height: calc(100vh - 300px);
}`, "",{"version":3,"sources":["webpack://./src/components/resource/list/table/columns/actions/video-modal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;AACjC","sourcesContent":[".videoWrapper :global iframe {\n  width: 100%;\n  height: 100vh;\n  max-height: calc(100vh - 300px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoWrapper": `video-modal_videoWrapper__9aRBI`
};
export default ___CSS_LOADER_EXPORT___;
